var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "feishu-callback-container" }, [
    _c("div", { staticClass: "callback-content" }, [
      _vm.loading
        ? _c("div", { staticClass: "loading-state" }, [
            _c("i", { staticClass: "el-icon-loading" }),
            _c("p", [_vm._v(_vm._s(_vm.$t("login.processing")))]),
          ])
        : _vm.success
        ? _c("div", { staticClass: "success-state" }, [
            _c("i", { staticClass: "el-icon-circle-check" }),
            _c("p", [_vm._v(_vm._s(_vm.$t("login.codeSent")))]),
            _c("p", { staticClass: "tip" }, [
              _vm._v(_vm._s(_vm.$t("login.closingWindow"))),
            ]),
          ])
        : _c("div", { staticClass: "error-state" }, [
            _c("i", { staticClass: "el-icon-circle-close" }),
            _c("p", [
              _vm._v(_vm._s(_vm.errorMessage || _vm.$t("login.invalidCode"))),
            ]),
            _c("p", { staticClass: "tip" }, [
              _vm._v(_vm._s(_vm.$t("login.closingWindow"))),
            ]),
          ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }